// Compiled using marko@4.28.10 - DO NOT EDIT
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry = require("marko/dist/runtime/components/registry"),
    marko_registerComponent = components_registry.r,
    marko_componentType = marko_registerComponent("/wetracker$1.0.0/src/components/sample_editor/templates/sample.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_attrs0 = {
        "class": "sample-editor"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("e11d0e"),
    marko_node0 = marko_createElement("div", {
        "class": "waveform"
      }, "1", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("canvas", {
          "class": "sample-canvas"
        }, null, null, 0),
    marko_attrs1 = {
        "class": "sample-controls"
      },
    marko_attrs2 = {
        "class": "control-panel"
      },
    marko_node1 = marko_createElement("div", {
        "class": "control-group basenote"
      }, "5", null, 9, 0, {
        i: marko_const_nextId()
      })
      .e("div", {
          "class": "control"
        }, null, null, 1)
        .e("button", {
            id: "octave-down",
            "class": "fa fa-fast-backward"
          }, null, null, 0)
      .t(" ")
      .e("div", {
          "class": "control"
        }, null, null, 1)
        .e("button", {
            id: "note-down",
            "class": "fa fa-step-backward"
          }, null, null, 0)
      .t(" ")
      .e("div", {
          "class": "control"
        }, null, null, 2)
        .e("input", {
            id: "basenote",
            value: "C-4"
          }, null, null, 0)
        .t(" ")
      .e("div", {
          "class": "control"
        }, null, null, 1)
        .e("button", {
            id: "note-up",
            "class": "fa fa-step-forward"
          }, null, null, 0)
      .t(" ")
      .e("div", {
          "class": "control"
        }, null, null, 1)
        .e("button", {
            id: "octave-up",
            "class": "fa fa-fast-forward"
          }, null, null, 0)
      .t(" "),
    marko_attrs3 = {
        "class": "control-group finetune"
      },
    marko_attrs4 = {
        "class": "control-group loop"
      },
    marko_node2 = marko_createElement("div", {
        "class": "control"
      }, "17", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("label", {
          "for": "finetune"
        }, null, null, 1)
        .t("Fine Tune"),
    marko_node3 = marko_createElement("div", {
        "class": "control"
      }, "19", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "fine-down",
          "class": "fa fa-minus"
        }, null, null, 0),
    marko_attrs5 = {
        "class": "control"
      },
    marko_node4 = marko_createElement("div", {
        "class": "control"
      }, "23", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("button", {
          id: "fine-up",
          "class": "fa fa-plus"
        }, null, null, 0),
    marko_node5 = marko_createElement("div", {
        "class": "control"
      }, "26", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("label", {
          "for": "loop"
        }, null, null, 1)
        .t("Loop"),
    marko_attrs6 = {
        "class": "control"
      },
    marko_node6 = marko_createElement("option", {
        value: "0"
      }, "30", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("None"),
    marko_node7 = marko_createElement("option", {
        value: "1"
      }, "31", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Forward"),
    marko_node8 = marko_createElement("option", {
        value: "2"
      }, "32", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Ping-pong");

function render(input, out, __component, component, state) {
  var data = input;

  out.e("div", marko_attrs0, "0", component, 2)
    .n(marko_node0, component)
    .e("div", marko_attrs1, "3", component, 1)
      .e("div", marko_attrs2, "4", component, 3)
        .n(marko_node1, component)
        .e("div", marko_attrs3, "16", component, 6)
          .n(marko_node2, component)
          .n(marko_node3, component)
          .t(" ")
          .e("div", marko_attrs5, "21", component, 2)
            .e("input", {
                id: "finetune",
                name: "finetune",
                value: "" + (data.sample ? data.sample.fine : 0)
              }, "22", component, 0)
            .t(" ")
          .n(marko_node4, component)
          .t(" ")
        .e("div", marko_attrs4, "25", component, 3)
          .n(marko_node5, component)
          .e("div", marko_attrs6, "28", component, 1)
            .e("select", {
                name: "loop",
                id: "loop",
                selected: "" + (data.sample ? data.sample.loop : 0)
              }, "29", component, 3)
              .n(marko_node6, component)
              .n(marko_node7, component)
              .n(marko_node8, component)
          .t(" ");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
